import {useState, type PropsWithChildren} from 'react'
import {TreeView} from '@primer/react'
import {ErrorBoundary} from '@github-ui/react-core/error-boundary'

export const NestedListViewErrorBoundary = ({
  children,
  onRetry,
  onDismiss,
  onError,
}: PropsWithChildren<{onRetry?: () => void; onError?: () => void; onDismiss?: () => void}>) => {
  const [hasError, setHasError] = useState(false)
  const [loadingError, setLoadingError] = useState('An error occured while loading items')

  return (
    <ErrorBoundary
      fallback={
        <>
          {hasError && (
            <TreeView.ErrorDialog
              onRetry={() => {
                setHasError(false)
                onRetry?.()
              }}
              onDismiss={() => {
                setHasError(false)
                onDismiss?.()
              }}
            >
              {loadingError}
            </TreeView.ErrorDialog>
          )}
          {children}
        </>
      }
      onError={error => {
        setHasError(true)
        if (error instanceof Error) {
          setLoadingError(error.message)
        }
        onError?.()
      }}
    >
      {children}
    </ErrorBoundary>
  )
}

try{ NestedListViewErrorBoundary.displayName ||= 'NestedListViewErrorBoundary' } catch {}